import styled from "styled-components";

import { PositionXType, PositionYType, TextAlignType } from "../../../interfaces/types";

export const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 32px 16px 16px 16px;
  flex-direction: column;
  gap: 8px; 
  border-radius: 8px; 
  border: 1px solid ${props => props.theme.colors.border};
`;

export const Input = styled.textarea<{textAlign?: TextAlignType}>`
  border: none;
  width: fit-content;
  outline: none;
  resize: none;
  overflow-y: hidden;

  /* ParagraphS */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  letter-spacing: 0.2px; 

  text-align: ${props => props.textAlign ?? "center"};

  color: ${props => props.theme.colors.title};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px; 
  letter-spacing: 0.2px; 
`;

export const TextLenght = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
`;

export const Wrapper = styled.div<{positionX?: PositionXType, positionY?: PositionYType}>`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: ${props => props.positionX ?? "center"};
  align-items: ${props => props.positionY ?? "center"};
`;